import {useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  setSelectedFocusLayer,
  selectSelectedFocusLayer,
  setSelectedGradientView as setSelectedGradientViewAction,
  setSelectedPopulationViewMode as setSelectedPopulationViewModeAction,
  selectSelectedPopulationViewMode
} from '../slices/focusLayerSlice'

export const useFocusLayer = () => {
  const dispatch = useDispatch()
  const selectedFocusLayer = useSelector(selectSelectedFocusLayer)
  const selectedPopulationViewMode = useSelector(selectSelectedPopulationViewMode)

  const updateFocusLayer = useCallback(
    (focusType) => {
      dispatch(setSelectedFocusLayer(focusType))
    },
    [dispatch]
  )

  // Maintain backward compatibility with original provider API
  const setSelectedFocusLayerCompat = useCallback(
    (focusType) => {
      dispatch(setSelectedFocusLayer(focusType))
    },
    [dispatch]
  )

  const setSelectedGradientView = useCallback(
    (gradientView) => {
      dispatch(setSelectedGradientViewAction(gradientView))
    },
    [dispatch]
  )

  const setSelectedPopulationViewMode = useCallback(
    (viewMode) => {
      dispatch(setSelectedPopulationViewModeAction(viewMode))
    },
    [dispatch]
  )

  return useMemo(
    () => ({
      selectedFocusLayer,
      setSelectedFocusLayer: setSelectedFocusLayerCompat,
      updateFocusLayer,
      setSelectedGradientView,
      selectedPopulationViewMode,
      setSelectedPopulationViewMode
    }),
    [
      selectedFocusLayer,
      setSelectedFocusLayerCompat,
      updateFocusLayer,
      setSelectedGradientView,
      selectedPopulationViewMode,
      setSelectedPopulationViewMode
    ]
  )
}
